import React from 'react'

import InfiniteScroll from '@src/components/InfiniteScroll'
import { Article } from '@models/Article'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ListBoxProps = {
  articles: Article[]
  subLine: string
  headline: string
  gtmClickType: string
}

const ListBox: React.FC<ListBoxProps> = ({
  articles,
  subLine,
  headline,
  gtmClickType,
}) => {
  const { locale } = useTranslation()

  return (
    <section className={style.listBox}>
      {locale === 'ja' && <span className={style.subLine}>{subLine}</span>}
      <h2 className={style.headline}>{headline}</h2>
      {articles.length > 0 ? (
        <InfiniteScroll articles={articles} gtmClickType={gtmClickType} />
      ) : (
        <p className={style.coming}>Coming soon...</p>
      )}
    </section>
  )
}

export default ListBox
